<template>
    <div>
        <Modal v-model="modal" :title="modelTitle" width="700px" :closable="false" :mask-closable="false">
            <div>
                <!-- {{certItem}} -->
                <Form ref="certFormValidate" :model="certItem" :rules="certRuleValidate" :label-width="140">
                    <FormItem label="持有职称/技术证书" prop="id">
                        <Input v-model.trim="certItem.id" placeholder="请输入持有职称/技术证书"></Input>
                    </FormItem>
                    <FormItem label="证书颁发机构" prop="name">
                        <Input v-model.trim="certItem.name" placeholder="请输入证书颁发机构"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type="primary" @click="handleConfirm">确认</Button>
                <Button type="primary" @click="handleCancel">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    props: {
        certItem: {
            type: Object,
            default: {},
        },
        modelTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            modal: false,
            certRuleValidate: {
                id: [
                    {
                        required: true,
                        message: "持有职称/技术证书不可为空",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "证书颁发机构不可为空",
                        trigger: "blur",
                    },
                ],
            },
            dateVal: [],
        };
    },
    watch: {
        modal(val, oldVal) {
            if (val) {
                this.$refs["certFormValidate"].resetFields();
            }
        },
    },
    methods: {
        handleCancel() {
            this.modal = false;
        },

        handleConfirm() {
            this.$refs["certFormValidate"].validate((valid) => {
                if (valid) {
                    // return
                    this.$emit("getCertItem", this.certItem);
                    this.modal = false;
                }
            });
        },
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/wumeigeren/components/ModalCert.vue